import React from 'react'
import PropTypes from 'prop-types'

const CheckBoxFieldMultiple = ({
  input,
  type = 'checkbox',
  meta,
  options,
  // css classes
  errorClassName,
  groupClassName = 'flex flex-row flex-wrap',
  liClassName = 'w-1/5 p-2',
  labelClassName,
  inputClassName,
  inputErrorClassName,
}) => {
  const handleOnChange = (isExist, value) => {
    let finalValue

    if (isExist) {
      finalValue = input.value.filter((v) => v !== value)
    } else {
      finalValue = [...input.value, value]
    }

    return input.onChange(finalValue)
  }

  return (
    <>
      <ul className={groupClassName}>
        {options.map((option, key) => {
          const isTrue = input.value.includes(option.value)

          return (
            <li className={liClassName} key={option.value ?? key}>
              <label className={`radio-container ${labelClassName}`}>
                {option.label}
                <input
                  checked={isTrue}
                  onChange={() => handleOnChange(isTrue, option.value)}
                  className={
                    meta.touched && meta.error
                      ? [inputClassName, inputErrorClassName].join(' ')
                      : inputClassName
                  }
                  type={type}
                />
                <span className="checkmark w-4 h-4 my-auto"></span>
              </label>
            </li>
          )
        })}
      </ul>
      {meta.touched && meta.error && <p className={errorClassName}>{meta.error}</p>}
    </>
  )
}

CheckBoxFieldMultiple.propTypes = {
  options: PropTypes.array.isRequired,
  input: PropTypes.object.isRequired,
  type: PropTypes.string,
  meta: PropTypes.object.isRequired,
  groupClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  liClassName: PropTypes.string,
  labelClassName: PropTypes.array,
  errorClassName: PropTypes.string,
  inputErrorClassName: PropTypes.string,
}

export default CheckBoxFieldMultiple
